import ApiHandler from "./ApiHandler";

const Location = {
  findAll: async (query) => await ApiHandler.i.auth().get(`/location/find-all?${query.toString()}`),
  findOlympiadStepDate: async (locationId, query) => await ApiHandler.i.auth().get(`/location/${locationId}/pivotal-date?${query.toString()}`),
  getAddress: async (locationId) => await ApiHandler.i.auth().get(`/location/${locationId}/address`),
  getListForEnrol: async (query) => await ApiHandler.i.auth().get(`/location/list-for-enrol?${query.toString()}`),
  getOne: async (locationId) => await ApiHandler.i.auth().get(`/location/${locationId}`),
  getSearchList: async (query) => await ApiHandler.i.auth().get(`/location/search-list?${query.toString()}`),
  getStatistics: async (locationId, stepId) => await ApiHandler.i.auth().get(`/location/${locationId}/statistics/${stepId}`),
  postOne: async (data, options) => await ApiHandler.i.auth().post('/location', data, options),
  putOne: async (locationId, data, options) => await ApiHandler.i.auth().put(`/location/${locationId}`, data, options),
};

export default Location;